var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 9.33329C8.73646 9.33329 9.33341 8.73634 9.33341 7.99996C9.33341 7.26358 8.73646 6.66663 8.00008 6.66663C7.2637 6.66663 6.66675 7.26358 6.66675 7.99996C6.66675 8.73634 7.2637 9.33329 8.00008 9.33329Z",
    stroke: "#AD4040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8266 5.17341C11.1985 5.5449 11.4936 5.98606 11.6949 6.47165C11.8962 6.95724 11.9998 7.47775 11.9998 8.00341C11.9998 8.52907 11.8962 9.04958 11.6949 9.53517C11.4936 10.0208 11.1985 10.4619 10.8266 10.8334M5.17329 10.8267C4.80139 10.4553 4.50635 10.0141 4.30505 9.5285C4.10376 9.04291 4.00015 8.5224 4.00015 7.99674C4.00015 7.47108 4.10376 6.95057 4.30505 6.46498C4.50635 5.97939 4.80139 5.53824 5.17329 5.16674M12.7133 3.28674C13.9631 4.53693 14.6652 6.23232 14.6652 8.00008C14.6652 9.76784 13.9631 11.4632 12.7133 12.7134M3.28663 12.7134C2.03682 11.4632 1.33472 9.76784 1.33472 8.00008C1.33472 6.23232 2.03682 4.53693 3.28663 3.28674",
    stroke: "#AD4040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastRed);
export default __webpack_public_path__ + "static/media/broadcast-red.6a40cd2328553540bac7f00f8b48d2cd.svg";
export { ForwardRef as ReactComponent };